import React, { useState } from "react"
import classes from "./ResultSet.module.css"
import Select, { createFilter } from "react-select"
import {
    useLocalStorage,
    get_all_orderable_gear,
    skillImage,
    getSkillName,
    SkillIDs,
    getGearLabel,
    default_single_style,
} from "../../../Utils"
import { useTranslation } from "react-i18next"
import { defaultMurchData } from "../../../DefaultEntries"
import gearHead from "../../../assets/json/parameters/GearInfoHead.json"

const ControlInit = props => {
    const { t } = useTranslation()
    //const reward_types = get_reward_types(t)
    const [currentOrder, setCurrentOrder] = useLocalStorage("finder_Vendor", defaultMurchData(t))
    const addEntry = () => {
        const new_arr = [...currentOrder]
        new_arr.push({
            gearSelected: { value: gearHead[0], type: 0, label: getGearLabel(t, gearHead[0], 0) },
            ordered: { main: 255, subs: [255, 255, 255] },
            received: { main: SkillIDs[gearHead[0].Skill], subs: [255, 255, 255] },
            receivedGear: false,
        })
        setCurrentOrder(new_arr)
    }

    const removeEntry = () => {
        const new_arr = [...currentOrder]
        new_arr.pop()
        setCurrentOrder(new_arr)
    }

    const changeOrder = (val, idx) => {
        const new_arr = [...currentOrder]
        new_arr[idx] = val
        setCurrentOrder(new_arr)
    }

    const changeSelectedGear = (val, idx) => {
        changeOrder(
            {
                ...currentOrder[idx],
                gearSelected: val,
                ordered: { main: 255, subs: [255, 255, 255] },
                received: { main: SkillIDs[val.value.Skill], subs: [255, 255, 255] },
            },
            idx
        )
    }

    const receiveGear = (val, idx) => {
        changeOrder(
            {
                ...currentOrder[idx],
                receivedGear: !currentOrder[idx].receivedGear,
            },
            idx
        )
    }

    const abilityOverwriteHandler = (idx, ability, val) => {
        const co = { ...currentOrder[idx] }
        switch (ability) {
            case 0:
                co.ordered.main = val
                break
            case 1:
            case 2:
            case 3:
                co.ordered.subs[(ability & 3) - 1] = val
                break
            case 4:
                co.received.main = val
                break
            case 5:
            case 6:
            case 7:
                co.received.subs[(ability & 3) - 1] = val
                break
            default:
                break
        }
        changeOrder(co, idx)
    }

    return (
        <div className={classes.WrapperNoScroll}>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentOrder.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("translation:LayoutMsg.Plz_GearOrder_00.100")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            {currentOrder.map((entry, idx) => {
                return (
                    <Entry
                        key={idx}
                        idx={idx}
                        gearChange={changeSelectedGear}
                        currentOrder={entry}
                        abilityOverwriteHandler={abilityOverwriteHandler}
                        change={receiveGear}
                    />
                )
            })}
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentOrder.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("translation:LayoutMsg.Plz_GearOrder_00.100")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} onClick={() => props.findSeed(currentOrder)}>
                    {t("misc:Recovery.ButtonSearch")}
                </button>
            </div>
        </div>
    )
}

const Entry = props => {
    const { t } = useTranslation()

    const orderable_gear = get_all_orderable_gear(t)
    const centerStyle = default_single_style()

    const toSkillImage = id => skillImage(getSkillName(id))
    const [loadAbility, setLoadAbility] = useState(-1)

    const overwriteAbilityHandler = val => {
        props.abilityOverwriteHandler(props.idx, loadAbility, val)
        setLoadAbility(i => ((i + 2) % 5) - 1)
    }

    const changeGear = e => {
        props.gearChange(e, props.idx)
        setLoadAbility(-1)
    }

    const loadNewAbility = e => {
        switch (e) {
            case 4:
                if (props.currentOrder.received.main !== props.currentOrder.ordered.main) {
                    props.abilityOverwriteHandler(props.idx, 4, props.currentOrder.ordered.main)
                } else {
                    props.abilityOverwriteHandler(props.idx, 4, SkillIDs[props.currentOrder.gearSelected.value.Skill])
                }
                break
            case 5:
            case 6:
            case 7:
                if (props.currentOrder.received.subs[(e & 3) - 1] !== props.currentOrder.ordered.subs[(e & 3) - 1]) {
                    props.abilityOverwriteHandler(props.idx, e, props.currentOrder.ordered.subs[(e & 3) - 1])
                } else {
                    props.abilityOverwriteHandler(props.idx, e, 255)
                }
                break
            default:
                break
        }
    }

    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: "any",
    }

    return (
        <div className={classes.OrderEntry}>
            <div className={classes.Ordered}>
                <div className={classes.Title}>
                    {props.idx + 1}. {t("misc:SeedListing.MurchOrder")}
                </div>
            </div>
            <div className={classes.GearNameOrdered}>
                <div className={classes.GearName}>
                    <Select
                        isSearchable
                        filterOption={createFilter(filterConfig)}
                        styles={centerStyle}
                        value={props.currentOrder.gearSelected}
                        onChange={e => changeGear(e)}
                        options={orderable_gear}
                        formatOptionLabel={elem => {
                            const url = `https://leanny.github.io/splat3/images/gear/${elem.value.__RowId}.png`
                            return (
                                <>
                                    <img src={url} width="32" alt={elem.label} />
                                    <span className={classes.Gap}> {elem.label}</span>
                                </>
                            )
                        }}
                    />
                </div>
            </div>
            <div className={classes.AbilityOrdered}>
                <div
                    className={classes.MainAbility}
                    onClick={() => setLoadAbility(0)}
                    style={loadAbility === 0 ? { border: "2px solid var(--border-color)" } : null}
                >
                    <img
                        src={toSkillImage(props.currentOrder.ordered.main)}
                        className={classes.abilityImage}
                        alt={toSkillImage(props.currentOrder.ordered.main)}
                    />
                </div>
                <div className={classes.SubAbilities}>
                    <div
                        className={classes.SubAbility}
                        onClick={() => setLoadAbility(1)}
                        style={loadAbility === 1 ? { border: "2px solid var(--border-color)" } : null}
                    >
                        <img
                            src={toSkillImage(props.currentOrder.ordered.subs[0])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.ordered.subs[0])}
                        />
                    </div>
                    <div
                        className={classes.SubAbility}
                        onClick={() => setLoadAbility(2)}
                        style={loadAbility === 2 ? { border: "2px solid var(--border-color)" } : null}
                    >
                        <img
                            src={toSkillImage(props.currentOrder.ordered.subs[1])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.ordered.subs[1])}
                        />
                    </div>
                    <div
                        className={classes.SubAbility}
                        onClick={() => setLoadAbility(3)}
                        style={loadAbility === 3 ? { border: "2px solid var(--border-color)" } : null}
                    >
                        <img
                            src={toSkillImage(props.currentOrder.ordered.subs[2])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.ordered.subs[2])}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.Received}>
                <div className={classes.Title}>{t("translation:CommonMsg.Glossary.Vendor")}</div>
            </div>
            <div className={classes.gearNameReceived}>
                <p>
                    {t("misc:SeedListing.MurchReceivedItem")}:
                    <input
                        className={classes.Checkbox}
                        type={"checkbox"}
                        onChange={e => props.change(e, props.idx)}
                        checked={props.currentOrder.receivedGear}
                    />
                </p>
            </div>
            <div className={classes.AbilityReceived}>
                <div className={classes.MainAbility} onClick={() => loadNewAbility(4)}>
                    <img
                        src={toSkillImage(props.currentOrder.received.main)}
                        className={classes.abilityImage}
                        alt={toSkillImage(props.currentOrder.received.main)}
                    />
                </div>
                <div className={classes.SubAbilities}>
                    <div className={classes.SubAbility} onClick={() => loadNewAbility(5)}>
                        <img
                            src={toSkillImage(props.currentOrder.received.subs[0])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.received.subs[0])}
                        />
                    </div>
                    <div className={classes.SubAbility} onClick={() => loadNewAbility(6)}>
                        <img
                            src={toSkillImage(props.currentOrder.received.subs[1])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.received.subs[1])}
                        />
                    </div>
                    <div className={classes.SubAbility} onClick={() => loadNewAbility(7)}>
                        <img
                            src={toSkillImage(props.currentOrder.received.subs[2])}
                            className={classes.abilityImage}
                            alt={toSkillImage(props.currentOrder.received.subs[2])}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.AbilitySelection}>
                {loadAbility !== -1 && loadAbility < 4 ? (
                    <div className={classes.extraZone}>
                        <div className={classes.abilityHeader}>{t("translation:LayoutMsg.Cmn_CstBase_00.001")}</div>
                        <div className={classes.abilitiyList}>
                            {Object.keys(SkillIDs)
                                .filter(elem => {
                                    return (
                                        SkillIDs[elem] < 100 ||
                                        SkillIDs[elem] === 255 ||
                                        ((loadAbility & 3) === 0 &&
                                            props.currentOrder.gearSelected.type === 0 &&
                                            SkillIDs[elem] >= 100 &&
                                            SkillIDs[elem] <= 103) ||
                                        ((loadAbility & 3) === 0 &&
                                            props.currentOrder.gearSelected.type === 1 &&
                                            SkillIDs[elem] >= 104 &&
                                            SkillIDs[elem] <= 107) ||
                                        ((loadAbility & 3) === 0 &&
                                            props.currentOrder.gearSelected.type === 2 &&
                                            SkillIDs[elem] >= 109 &&
                                            SkillIDs[elem] <= 111)
                                    )
                                })
                                .map((ability, idx) => {
                                    return (
                                        <div key={idx} onClick={() => overwriteAbilityHandler(SkillIDs[ability])}>
                                            <img
                                                src={skillImage(ability)}
                                                className={classes.abilityImage}
                                                alt={ability}
                                            />
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default ControlInit
